<template>
    <div v-html="'About'"/>
</template>

<script>
export default { name: "About" };
</script>